import PasswordResetContainer from 'containers/auth/PasswordResetContainer';
import React from 'react';

export default function PasswordReset() {
  return <PasswordResetContainer jestSubmit={() => {}} />;
}
